import { createPinia } from 'pinia'
import { createApp } from 'vue'

// Highlight.js
import 'highlight.js/styles/github-dark-dimmed.css'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import hljs from 'highlight.js/lib/common'
import hljsVuePlugin from '@highlightjs/vue-plugin'

// Components and default styles
import { fusionComponents } from '@/plugins/components'
import '@fusion/saas-components-v3/styles'

// Active theme
import { fusionTheme } from './plugins/theme'

// I18n
import { i18n } from '@/plugins/i18n'

// Vuetify
import { vuetify } from '@/plugins/vuetify'

// Styles
import '@fontsource/roboto' // Defaults to weight 400
import '@fontsource/roboto/300.css' // Specify weight
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Override styles
import './styles/global.scss'

// Fusion Auth
import Auth0Plugin, { getAuthOptions } from '@/plugins/auth'
import { permissions } from '@/plugins/permissions'

import App from '@/App.vue'
import { getRouter } from '@/router'

const setup = async () => {
  const app = createApp(App)
  const router = await getRouter(app)
  const pinia = createPinia()
  app.use(router)
  app.use(Auth0Plugin, getAuthOptions(router))
  app.use(pinia)
  app.use(i18n)
  app.use(vuetify)
  app.use(hljsVuePlugin)
  app.use(fusionComponents)
  app.use(fusionTheme)
  app.use(permissions)
  app.mount('#app')
}

setup()
